import { debounce } from "throttle-debounce";

const Paycheck = (target) => {
  // * PaycheckCalculator.cshtml
  // * SalaryController.cs

  const form = target;
  const el = {
    button: form.querySelector(`button[type="submit"]`),
    callout: form.querySelector(`.callout`),
    dynamicInputs: [
      form.querySelector(`[name="DayWorkSalary"]`),
      form.querySelector(`[name="HourlyOverTime"]`),
      form.querySelector(`[name="AfterWorkTime"]`),
      form.querySelector(`[name="HourlyOverTime"]`),
      form.querySelector(`[name="HourlyOverTime"]`),
      form.querySelector(`[name="Other1"]`),
      form.querySelector(`[name="Other2"]`),
      form.querySelector(`[name="PrivatePensionPercentage"]`),
      form.querySelector(`[name="TotalExcemptTax"]`),
      form.querySelector(`[name="OtherTax"]`),
      form.querySelector(`[name="PrePaidSalary"]`),  
      form.querySelector(`[name="CalculatedPerks"]`),
    ],
    requiredInputs: {
      percentage: form.querySelector(`[name="DayWordPercentage"]`),
      salary: form.querySelector(`[name="MonthlySalary"]`),
      personalDiscount: form.querySelector(`[name="PersonalDiscount"]`),
    },
    results: form.querySelector(`.calculator__paycheck-results`),
    resultsAccordion: form.querySelector(`.accordion`),
    rows: {
      step1: form.querySelectorAll(`[data-step="1"]`),
      step2: form.querySelectorAll(`[data-step="2"]`),
      step3: form.querySelectorAll(`[data-step="3"]`),
      step4: form.querySelectorAll(`[data-step="4"]`),
    },
  };

  el.rows.hidden = [el.rows.step2, el.rows.step3, el.rows.step4];

  let submitted = false;

  const method = {
    init: () => {
      const printButton = document.getElementById("calculator__paycheckPrint");

      if (printButton) {
        printButton.addEventListener("click", () => {
          const tempAction = form.getAttribute("action");
          form.setAttribute("action", "/surface/salary/CalculatePrint");
          form.setAttribute("target", "_blank");
          form.submit();
          form.setAttribute("action", tempAction);
        });
      }
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        method.submitForm(true);
      });

      const VacationPercentageRadios = form.querySelectorAll('[name="VacationPercentage"]');

      for (let i = 0; i < VacationPercentageRadios.length; i++) {
        VacationPercentageRadios[i].addEventListener(
          "change",
          debounce(250, method.recalculateResults)
        );
      }

      el.dynamicInputs.forEach((input) => {
        input.addEventListener("blur", debounce(250, method.recalculateResults));
      });

      el.requiredInputs.percentage.addEventListener(
        "blur",
        debounce(200, method.allowResults)
      );
      el.requiredInputs.salary.addEventListener(
        "blur",
        debounce(200,  method.allowResults)
      );
      el.requiredInputs.personalDiscount.addEventListener(
        "blur",
        debounce(200, method.allowResults)
      );

      el.results.style.display = "none";
      el.resultsAccordion.style.display = "none";
      el.rows.hidden.forEach((r) => {
        const rr = r;
        rr.forEach((rrr) => {
          const rrrr = rrr;
          rrrr.style.display = "none";
        });
      });
    },

    submitForm: async (showResults) => {
      const data = new FormData(form);
      const action = form.getAttribute("action");
      const formMethod = form.getAttribute("method");

      if (el.callout) el.callout.remove();
      el.button.disabled = true;
      el.button.classList.add("button--loading");

      fetch(action, {
        method: formMethod,
        body: data,
      })
        .then((res) => res.json())
        .then((response) => {
          if (response.success) {
            if (showResults) submitted = true;
            method.renderResults(response.result);
            el.button.classList.remove("button--loading");
            el.button.disabled = false;
          } else {
            method.renderError(response.message, "error");
            el.button.classList.remove("button--loading");
            el.button.disabled = false;
          }
        })
        .catch((ex) => {
          // console.log(ex);
          method.renderError(`Server error: ${ex}`, "error");
        });
    },

    allowResults: () => {
      //* When the first 3 fields in the form are changed, check if they have all been filled in and the form can be fully submitted
      //Added after being pointed out that if personal discount being erased and no number is in the field then a NaN appeared in Deduction. VEV
      if (el.requiredInputs.personalDiscount.value.length == 0)
        el.requiredInputs.personalDiscount.value = "0";
        
      if (
        el.requiredInputs.percentage.value.length > 0 ||
        el.requiredInputs.salary.value.length > 0 ||
        el.requiredInputs.personalDiscount.value.length > 0
      ) {
        el.rows.hidden.forEach((rows) => {
          rows.forEach((row) => row.removeAttribute("style"));
        });

        method.submitForm(true);

        if (submitted) {
          el.results.removeAttribute("style");
          el.resultsAccordion.removeAttribute("style");
        }
      } else {
        el.results.style.display = "none";
        el.resultsAccordion.style.display = "none";
        el.rows.hidden.forEach((rows) => {
          rows.forEach((row) => {
            const r = row;
            r.style.display = "none";
          });
        });
      }
    },

    renderResults: (response) => {
      if (submitted) {
        el.results.removeAttribute("style");
        el.resultsAccordion.removeAttribute("style");
      }

      //* Salary % / rate section
      form.querySelector(`[name="TotalSalary"]`).value = response.totalSalary;

      //* Other salaries and benefits section
      form.querySelector(`[name="DayWork"]`).value = response.hourlySalaryDayWork;
      form.querySelector(`[name="OverTime"]`).value = response.hourlySalaryWorkOvertime;
      form.querySelector(`[name="AfterWork"]`).value =  response.hourlySalaryAfterWork;

      //* Total salaries section
      form.querySelector(`[name="GrandTotalSalary"]`).value = response.grandTotalSalarySum;
      
      //* deductions section
      form.querySelector(`[name="PaidTaxStep1"]`).value = response.paidTaxStep1;
      form.querySelector(`[name="PaidTaxStep2"]`).value = response.paidTaxStep2;
      form.querySelector(`[name="PaidTaxStep3"]`).value = response.paidTaxStep3;
      form.querySelector(`[name="TaxSumTotal"]`).value = response.taxSumtotal;
      form.querySelector(`[name="TaxPaidTotal"]`).value = response.taxPaidTotal;
      form.querySelector(`[name="PensionDeduction"]`).value = response.pensionDeduction;
      form.querySelector(`[name="PrivatePensionDeduction"]`).value = response.privatePensionDeduction;
      form.querySelector(`[name="MembershipFee"]`).value = response.membershipFee;

      form.querySelector(`[data-field="TotalDeduction"]`).innerText = response.totalDeduction.toLocaleString(
        "is-IS"
      ).replace(/,/g, ".");

      //* Holiday hours section
      form.querySelector(`[name="VacationHoursValue"]`).value = response.vacationHours;
      
      //* Form end Total salaries
      form.querySelector(`[data-field="GrandTotalSalary"]`).innerText = response.grandTotalSalarySum.toLocaleString(
        "is-IS"
      ).replace(/,/g, ".");

      //* Form end Final total after deductions
      form.querySelector(`[data-field="SalaryTotalPaid"]`).innerText = response.salaryTotalPaid.toLocaleString(
        "is-IS"
      ).replace( /,/g, ".");

      //* Employer contribution values
      form.querySelector(`[data-field="ContributionPension"]`).innerText = response.contributionPension.toLocaleString(
        "is-IS"
      ).replace(/,/g, ".");

      form.querySelector( `[data-field="ContributionPrivatePension"]`).innerText = response.contributionPrivatePension.toLocaleString(
        "is-IS"
      ).replace(/,/g, ".");
      form.querySelector(`[data-field="ContributionSickFund"]`).innerText = response.contributionSickFund.toLocaleString(
        "is-IS"
      ).replace(/,/g, ".");
      form.querySelector(`[data-field="ContributionVacationFund"]`).innerText = response.contributionVacationFund.toLocaleString(
        "is-IS"
      ).replace(/,/g, ".");
      form.querySelector(`[data-field="ContributionVocationalFund"]`).innerText = response.contributionVocationalFund.toLocaleString(
        "is-IS"
      ).replace(/,/g, ".");
      form.querySelector(`[data-field="ContributionRehabilitationFund"]`).innerText = response.contributionRehabilitationFund.toLocaleString(
        "is-IS"
      ).replace(/,/g, ".");
    },

    recalculateResults: () => {
      //* When some fields are changed the form needs to be resubmitted to get the calculations from the service
      console.log("=== recalculateResults")
      //* Other salaries and benefits section
      form.querySelector(`[name="DayTotalSalary"]`).value = Math.round(
        form.querySelector(`[name="DayWorkSalary"]`).value *
          form.querySelector(`[name="DayWork"]`).value
      );
      form.querySelector(`[name="TotalOverTime"]`).value = Math.round(
        form.querySelector(`[name="HourlyOverTime"]`).value *
          form.querySelector(`[name="OverTime"]`).value
      );
      form.querySelector(`[name="TotalAfterWork"]`).value = Math.round(
        form.querySelector(`[name="AfterWorkTime"]`).value *
          form.querySelector(`[name="AfterWork"]`).value
      );
      form.querySelector(`[name="TotalOtherSalary"]`).value = Math.round(
        form.querySelector(`[name="Other1"]`).value *
          form.querySelector(`[name="Other2"]`).value
      );
      
      //* Deductions section
      form.querySelector(`[name="PrivatePensionDeduction"]`).value = Math.round(
        (form.querySelector(`[name="PrivatePensionPercentage"]`).value / 100) *
        (form.querySelector(`[name="GrandTotalSalary"]`).value - (parseFloat(form.querySelector(`[name="TotalExcemptTax"]`).value) + parseFloat(form.querySelector(`[name="OtherTax"]`).value)) )  //Other should not be included in pension calculation VEV 17.2.2021
      );

      method.submitForm(false);
    },

    renderError: (message, type) => {
      el.results.style.display = "none";
      form.insertAdjacentHTML(
        "beforeend",
        `<div class="callout callout--${type}">${message}</div>`
      );
    },
  };

  method.init();
};

export default Paycheck;
